module.exports = "https://cdn-skillquest.mathletics.com/app/174/assets/images/365edfd655e23216de63dc52f3eb6ec6.svg";